import { render, staticRenderFns } from "./requirement-modal.vue?vue&type=template&id=568e335c&scoped=true"
import script from "./requirement-modal.vue?vue&type=script&lang=js"
export * from "./requirement-modal.vue?vue&type=script&lang=js"
import style0 from "./requirement-modal.vue?vue&type=style&index=0&id=568e335c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e335c",
  null
  
)

export default component.exports